import { Button, Dialog, ErrorText, StateRoster } from '@dataroom/shared';
import { useDdStates, useSetDdStates } from '@/api/hooks';

/**
 * The room's STATE ROSTER (issue #157): the states the company operates in, is
 * registered in, or has employees in. Each chosen state gets its own checklist
 * categories with that state's real filings. Embedded under the Financial roster
 * question naming "[State]", and inside {@link DdStatesDialog}.
 */
export function DdStatesPanel({ roomId }: { roomId: string }) {
  const states = useDdStates(roomId);
  const setStates = useSetDdStates(roomId);
  if (states.isPending) return <p className="text-sm text-muted-foreground">Loading states…</p>;
  if (states.error) return <ErrorText error={states.error} />;
  return <StateRoster data={states.data} onSave={(codes) => setStates.mutateAsync(codes)} />;
}

/** The state roster in a dialog — opened from a "[State]" checklist item. */
export function DdStatesDialog({ roomId, onClose }: { roomId: string; onClose: () => void }) {
  return (
    <Dialog
      title="States"
      description="Choose every state the company operates in, is registered in, or has employees in. Each gets its own checklist items named after that state's filings."
      size="lg"
      onClose={onClose}
      footer={
        <Button variant="outline" className="ml-auto" onClick={onClose}>
          Done
        </Button>
      }
    >
      <DdStatesPanel roomId={roomId} />
    </Dialog>
  );
}
